import { BulaIcon } from '@/components/icons/bula';
import cn from 'classnames';

interface BulaThumbProps {
  pdfUrl: string;
  className?: string;
}

export const BulaThumb: React.FC<BulaThumbProps> = ({ pdfUrl, className }) => {
  const stopSwiperFromStealing = (
    e: React.MouseEvent | React.TouchEvent | React.PointerEvent,
  ) => {
    e.stopPropagation();
    // Only mousedown: preventDefault on touch/pointer would block the <a> click on iOS.
    if (e.type === 'mousedown') {
      e.preventDefault();
    }
  };

  return (
    <a
      href={pdfUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Abrir bula em PDF"
      onPointerDown={stopSwiperFromStealing}
      onMouseDown={stopSwiperFromStealing}
      onTouchStart={stopSwiperFromStealing}
      className={cn(
        'swiper-no-swiping relative flex flex-col items-center justify-center overflow-hidden rounded border border-border-200 border-opacity-75 cursor-pointer hover:opacity-75 bg-white appearance-none p-0 no-underline',
        className
      )}
    >
      <div className="flex-[2] flex items-center justify-center p-2 bg-white w-full">
        <BulaIcon className="w-10 h-10" />
      </div>
      <div className="flex-1 w-full bg-[#F48473] text-white text-center flex items-center justify-center">
        <span className="text-xs font-medium">BULA</span>
      </div>
    </a>
  );
};
